import {getPrefixedUrl} from "../../../utils/utils";
import {getImageShape, getResolutionsForMicron, getTileLayer, getTilingZoomLevels,} from "../utils/map_utils";
import {getProjection} from "../../neotileviewer/tile_viewer_map_utils";
import TileViewLayer from "./TileViewLayer";

class RescanLayer extends TileViewLayer {
    id = "rescanLayer";
    label = "Till Take 0";

    createLayer = () => {
        let tileSize = [this.props.slide.tile_width, this.props.slide.tile_height];
        let imageShape = getImageShape(this.props.slide);
        let projection = getProjection(imageShape);
        let resolutions = getResolutionsForMicron(getTilingZoomLevels(this.props.slide), this.props.slide.uperpixel)

        let rescanUrlSuffix = `tiled_pre_rescan/{z}/x{x}y{y}.` + this.props.slide.img_type;
        let rescanUrl = getPrefixedUrl(rescanUrlSuffix, this.props.slide, true);
        let extent = this.props.map.getView().getProjection().getExtent();
        return getTileLayer(this.id, tileSize, projection, resolutions, rescanUrl, extent);
    }
}

export default RescanLayer;
